module.exports = __webpack_public_path__ + "static/media/hugModal.8cb0f846.jpg";